/* Rquiere de errors.js */

var axiosAWN = {
	methods:{
		axiosAWNasync(message, method, url, responseFunction, data = null, headers = null) {
			headers = (headers == null) ? this.getHeaders : headers
			switch(method) {
				case 'DELETE':
					this.axiosAWNDelete('async', message, url, responseFunction, headers)
					break;
				case 'GET':
					this.axiosAWNGet('async', message, url, responseFunction, headers)
					break;
				case 'POST':
					this.axiosAWNPost('async', message,url, data, responseFunction, headers)
					break;
				case 'PUT':
					this.axiosAWNPut('async', message, url, data, responseFunction, headers)
					break;
				default:
					this.axiosAWNError('No está determinado el metodo de comunicación (DELETE, GET, POST, PUT)')
					break;
			}
		},
		axiosAWNasyncBlock(message, method, url, responseFunction, data = null, headers = null) {
			headers = (headers == null) ? this.getHeaders : headers
			switch(method) {
				case 'DELETE':
					this.axiosAWNDelete('asyncBlock', message, url, responseFunction, headers)
					break;
				case 'GET':
					this.axiosAWNGet('asyncBlock', message, url, responseFunction, headers)
					break;
				case 'POST':
					this.axiosAWNPost('asyncBlock', message, url, data, responseFunction, headers)
					break;
				case 'PUT':
					this.axiosAWNPut('asyncBlock', message, url, data, responseFunction, headers)
					break;
				default:
					this.axiosAWNError('No está determinado el metodo de comunicación (DELETE, GET, POST, PUT)')
					break;
			}
		},
		axiosAWNDelete(type, message, url, responseFunction, headers) {
			this.$awn[type](
				this.axios.delete(url, { headers: headers }),
				response => { this.axiosAWNResponse(responseFunction, response) },
				error => { this.axiosAWNError(error.message, responseFunction) },
				message
			);
		},
		axiosAWNGet(type, message, url, responseFunction, headers) {
			this.$awn[type](
				this.axios.get(url, { headers: headers }),
				response => { this.axiosAWNResponse(responseFunction, response) },
				error => { this.axiosAWNError(error.message, responseFunction) },
				message
			);
		},
		axiosAWNPost(type, message, url, data, responseFunction, headers) {
			this.$awn[type](
				this.axios.post(url, data, { headers: headers }),
				response => { this.axiosAWNResponse(responseFunction, response) },
				error => { this.axiosAWNError(error.message, responseFunction) },
				message
			);
		},
		axiosAWNPut(type, message, url, data, responseFunction, headers) {
			this.$awn[type](
				this.axios.put(url, data, { headers: headers }),
				response => { this.axiosAWNResponse(responseFunction, response) },
				error => { this.axiosAWNError(error.message, responseFunction) },
				message
			);
		},
		axiosAWNResponse(responseFunction, response) {
			try {
				this[responseFunction](response)
			} catch (error) {
				this.axiosAWNError(error)
			}
		},
		axiosAWNError(error, responseFunction) {
			this.$awn.alert(error)
			console.log(error)
			try {
				this[responseFunction + 'Error'](error)
			} catch (error) {
				this.$awn.alert('Function ' + responseFunction + 'Error not found')
			}
		},
	},
};

export default axiosAWN;